// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  Component,
  HostBinding,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { v1 as uuidV1 } from 'uuid';
import { BASE_SERVICE } from '../../../../services/base.service';
import { TASK_SERVICE } from '../../../../services/task.service';
import { USER_SERVICE, UserServiceInterface } from '../../../../services/user.services';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { FileUploadComponent } from '../../dynamic-form/sub-modules/file-upload/file-upload.component';
import { ParallelTaskService } from '../../dynamic-form/sub-modules/parallel-tasks/parallel-task.service';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';
import { InputLinkComponent } from '../input-link/input-link.component';

@Component({
  selector: 'lbca-files-download',
  templateUrl: './files-download.component.html',
  imports: [forwardRef(() => FileUploadComponent), InputLinkComponent],
})
export class FilesDownloadComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private parallelTaskService = inject(ParallelTaskService);
  readonly taskService = inject(TASK_SERVICE);
  readonly baseService = inject(BASE_SERVICE);
  private overlay = inject(Overlay);
  private dynamicFormService = inject(DynamicFormService);

  private popupFeedController = new PopupInterfaceCommunication();

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateFeedbackRedirect') templateFeedbackRedirect!: TemplateRef<any>;

  public isDisabled: boolean = false;
  public disableControl: boolean = true;
  public dataAttr!: any;
  public linkAudience: string = '';
  public loadConfiguration: boolean = false;
  public timeout: any = null;
  public cardInfo: any;
  public loadPage!: boolean;
  public configuration: any = {};
  public hasFiles: boolean = false;

  public changeButtonConfigurations = {
    enabled: false,
    loading: false,
    label: 'Alterar arquivos',
  };
  public templateFeedbackRedirectMessage =
    'Aguarde, a edição está sendo preparada e você será redirecionado(a)!';

  @Input() entityData: any;
  flowId: any;

  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  @Input('configuration')
  set _configuration(data: any) {
    this.configuration = data;
  }

  @Input() set disabled(disabled) {
    this.isDisabled = false;
  }

  @Input() context: any = {};

  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  ngOnInit(): void {
    // const { params } = this.route.snapshot;
    // this.dataAttr = { processNumber: params.id }
    const { flowId, processId } = this.dynamicFormService.formControlStructure?.formMetadata || {};
    this.flowId = flowId;
    this.dataAttr = { processNumber: processId };
    this.loadConfiguration = true;
    this.disableControl = true;
    this.configuration.context = this.context[this.configuration?.contextKey ?? 'id'];
  }
  setChangeButtonVisibilty(processId: string) {
    this.baseService.getOneProcess(processId).subscribe((resp: any) => {
      const { status = null, integrationStatus = null } = resp[0];
      if (status === 'open' && integrationStatus !== 'sincronizando' && this.hasFiles) {
        this.changeButtonConfigurations.enabled = true;
      }
    });
  }

  linkAud(value: any) {
    this.linkAudience = value;
  }

  setHasFile(hasFile: any) {
    this.hasFiles = hasFile;
    this.setChangeButtonVisibilty(this.dataAttr.processNumber);
  }

  public editData() {
    const user: any = this.userService.getUserInfo();

    const params = {
      context: 'intermediate_start_court_hearing_docs',
      processId: this.route.snapshot.params['id'],
    };

    this.loadPage = false;
    this.popupFeedController.show(this.templateFeedbackRedirect);

    const value = {
      taskType: 'intermediate_start_court_hearing_docs',
      user: user.fullname,
      userId: user.userId,
      processId: params.processId,
      userEditBase: user.userId,
      asyncTaskId: uuidV1(),
      courtHearingId: this.context[this.configuration?.contextKey ?? 'id'],
    };

    this.changeButtonConfigurations.loading = true;

    this.parallelTaskService.createAndSendParallelRequest([value], params).subscribe((resp) => {
      this.getHistory(value.asyncTaskId);
    });
  }

  private getHistory(asyncTaskId: string) {
    this.loadPage = false;
    const params = {
      context: 'intermediate_start_court_hearing_docs',
      processId: this.route.snapshot.params['id'],
    };

    this.parallelTaskService.getParallelHistory(params).subscribe((resp) => {
      if (resp.pending) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.getHistory(asyncTaskId), 2000);
      } else if (Array.isArray(resp) && resp.length > 0) {
        this.recursiveGetAndWaitAsyncTask(asyncTaskId);
      } else {
        this.loadPage = false;
        this.popupFeedController.close();
      }
    });
  }

  private recursiveGetAndWaitAsyncTask(asyncTaskId: string) {
    this.taskService.getTaskByAsyncTaskId({ asyncTaskId }).subscribe((resp: any) => {
      if (resp.Count > 0) {
        const task = resp.Items[0];
        this.templateFeedbackRedirectMessage = 'Sua edição foi criada! Redirecionando!';
        this.taskService.acceptTask(task).subscribe((resp) => {
          this.changeButtonConfigurations.loading = false;
          this.loadPage = true;
          this.popupFeedController.close();
          this.router.navigate([`/task/task-form/${task.id}`]);
        });
      } else {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.recursiveGetAndWaitAsyncTask(asyncTaskId), 2000);
      }
    });
  }
}

export interface laneData {
  courtHearing: any;
  courtHearingAttendanceType: 'virtual' | 'presential';
  courtHearingDate: string;
  courtHearingTime: string;
  courtHearingType: string;
  id: string;
  audienceLink: string;
}
